import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import commonStyles from '../../Common/commonStyles';

const styles = StyleSheet.create({
  attachmentText: {
    ...commonStyles.fontS,
    fontWeight: 'bold',
    marginBottom: '2%',
  },
  attachmentImage: {
    maxHeight: 275,
    objectFit: 'contain',
    width: '100%',
    border: '1.5px solid #000',
    borderRadius: 4,
    marginBottom: '2%',
    padding: '1%',
  },
});

function SpecificationFiles({ files, t }) {
  return (
    <View>
      {files
        .filter((file) => file?.file)
        .map((file, index) => (
          <View key={file?.id} wrap={false}>
            <Text style={styles.attachmentText}>{`${t('attachment')} ${index + 1}`}</Text>
            <Image src={file.file} style={styles.attachmentImage} />
          </View>
        ))}
    </View>
  );
}

export default withTranslation()(SpecificationFiles);
